document.addEventListener('DOMContentLoaded', () => {

  /* ===============================
     TESTIMONIAL SLIDER
  ================================ */
  const testimonialSlider = document.querySelector('.testimonial-slider');
  if (testimonialSlider instanceof Element) {
    new Swiper(testimonialSlider, {
      loop: true,
      spaceBetween: 20,
      slidesPerView: 1,
      
      autoplay: {
        delay: 3000,
      },

      pagination: {
      el: '.swiper-pagination',
      clickable: true,
      },

      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  }

  /* ===============================
     STORIES SLIDER
  ================================ */
  const storiesSlider = document.querySelector('.stories-slider');
  if (storiesSlider instanceof Element) {
    new Swiper(storiesSlider, {
      loop: true,
      spaceBetween: 20,
      slidesPerView: 1,
      
      autoplay: {
        delay: 3000,
      },

      pagination: {
      el: '.swiper-pagination',
      clickable: true,
      },

      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  }

});
